import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobExecute = {
    path: "/job/:id",
    method: RouteHttpVerb.POST
};
export { locationRestJobExecute };
